import * as React from 'react';
import { Row, Col } from 'antd';

import './LoginLayout.css';

export default (props) => (
  <div className='grad'>
    <Row justify="center" className="loginContainer">
        <Col xs={24} md={12} >
            <div>
                {/* <img className="login-logo" alt="logo" src="./assets/images/logo12.png" /> */}
                <img style={{borderRadius:'5px'}} className="login-logo" alt="logo" src="./assets/images/logo12.png" />
            </div>
            <div className="layout-content radiusContent">
                {props.children}
            </div>
            
        </Col>
    </Row>
    
    <svg viewBox="0 0 1440 320">
      <path fill="#096dd9" fillOpacity="1" d="M0,160L80,149.3C160,139,320,117,480,112C640,107,800,117,960,106.7C1120,96,1280,64,1360,48L1440,32L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path>
    </svg>
  </div>

);



// WEBPACK FOOTER //
// ./src/components/LoginLayout.jsx